var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"personalize-packaging-modal","classes":['modal-window'],"transition":"scale","scrollable":"","adaptive":"","width":900,"height":"auto"}},[_c('div',{staticClass:"modal-container"},[_c('personalize-packaging',{on:{"create-treatment":_vm.hideModal}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }